module.exports = {
      id: "icon-premium-usage",
      viewBox: "0 0 40 40",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#icon-premium",
      toString: function () {
        return this.url;
      }
    }